import React, { useEffect, useState } from "react";
import { Button, Checkbox, DatePicker, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EditOutlined, EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import {
  ApiURL,
  oilparttwologdownloadPdfUrl,
} from "../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import VoyageDetails from "../../../components/VoyageDetails";
import { formatDate } from "../../../utils/dateFormatter";
import useVoyageList from "../../../hooks/useVoyageList";
import useUserData from "../../../hooks/useUserData";
import dayjs from "dayjs";
import { dateRanges } from "../../../Data/data";
import { DOWNLOADPDF } from "../../../utils/downloadPdf";
import RequestFormModal2 from "../../../components/RequestFormModel_orb2";
const { RangePicker } = DatePicker;

const ListOilRecordLog = () => {
  const navigate = useNavigate();
  const user = useUserData();
  const { voyageList } = useVoyageList();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const [selectedChiefRows, setSelectedChiefRows] = useState([]);
  const [selectedMasterRows, setSelectedMasterRows] = useState([]);
  const [isModalVisible, setModalVisible] = useState(false);
  const [record_id, set_record_id] = useState("");
  const [dates, setDates] = useState([dayjs().subtract(2, "day"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD")) || [];

  useEffect(() => {
    const staffData = JSON.parse(
      localStorage.getItem("staff_dashboard") || "{}"
    );
    set_staff_dashboard(staffData);
    localStorage.setItem("viewOnly", 0);
    if (voyage_ids) LIST_OIL_RECORD_LOGBOOK_API(voyage_ids);
  }, []);

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find(
        (voyage) => voyage.voyage_status === true
      );
      set_voyage_status(runningVoyage?.voyage_status || false);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
        LIST_OIL_RECORD_LOGBOOK_API(runningVoyage.id);
      }
    }
  }, [voyageList]);

  const LIST_OIL_RECORD_LOGBOOK_API = (voyage_id) => {
    try {
      set_page_loader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", voyage_id);
      FORM_DATA.append("orb_part", "2");
      post(ApiURL.list_orb_records_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const reversedData = res.records?.map((item) => ({
            ...item,
            key: item.record_id.toString(),
            chiefReviewed: item.reviewed_by_chief_officier || false,
            masterReviewed: item.reviewed_by_master || false,
            o_code:
              item.reviewed_by_chief_officier &&
              item.reviewed_by_master &&
              item.code_category == "O"
                ? false
                : true,
          }));
          setFilteredData(reversedData);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  const CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX = (record_id, check_type) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", record_id);
    FORM_DATA.append("chief_reviewed", check_type);
    FORM_DATA.append("orb_part", "2");
    post(ApiURL.update_single_checkbox_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success message !!", res?.message);
        LIST_OIL_RECORD_LOGBOOK_API(voyage_ids);
      } else {
        ErrorToast("Error message", res?.message);
      }
    });
  };

  const CHANGE_ALL_CHIEF_MASTER_REVIEW_CHECK_BOX = (check_type) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("chief_reviewed", check_type);
    FORM_DATA.append("orb_part", "2");
    post(ApiURL.update_multiple_checkboxes_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success message !!", res?.message);
        LIST_OIL_RECORD_LOGBOOK_API(voyage_ids);
      } else {
        ErrorToast("Error message", res?.message);
      }
    });
  };

  const handleChiefCheckboxChange = (e, record, index) => {
    if (user?.data?.designation !== "Chief Officer") return;
    const checked = e.target.checked;
    const updatedData = [...filteredData];
    updatedData[index].chiefReviewed = checked;
    if (checked) {
      CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX(record?.record_id, 2);
      setSelectedChiefRows([...selectedChiefRows, record.key]);
    } else {
      CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX(record?.record_id, 2);
      setSelectedChiefRows(
        selectedChiefRows.filter((key) => key !== record.key)
      );
      updatedData[index].masterReviewed = false;
      setSelectedMasterRows(
        selectedMasterRows.filter((key) => key !== record.key)
      );
    }
    setFilteredData(updatedData);
  };

  const handleMasterCheckboxChange = (e, record, index) => {
    if (user?.data?.designation !== "Captain") return;
    const checked = e.target.checked;
    const updatedData = [...filteredData];
    updatedData[index].masterReviewed = checked;
    if (checked) {
      CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX(record?.record_id, 1);
      setSelectedMasterRows([...selectedMasterRows, record.key]);
    } else {
      CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX(record?.record_id, 1);
      setSelectedMasterRows(
        selectedMasterRows.filter((key) => key !== record.key)
      );
    }
    setFilteredData(updatedData);
  };

  const handleSelectAllChief = (e) => {
    if (user?.data?.designation !== "Chief Officer") return;
    const checked = e.target.checked;
    const updatedData = filteredData.map((item) => ({
      ...item,
      chiefReviewed: checked,
      masterReviewed: checked ? item.masterReviewed : false,
    }));
    setFilteredData(updatedData);
    setSelectedChiefRows(checked ? filteredData.map((item) => item.key) : []);
    CHANGE_ALL_CHIEF_MASTER_REVIEW_CHECK_BOX(2);
    if (!checked) {
      setSelectedMasterRows([]);
    }
  };

  const handleSelectAllMaster = (e) => {
    // Only allow Master to modify this
    if (user?.data?.designation !== "Captain") return;
    const checked = e.target.checked;
    const updatedData = filteredData.map((item) => ({
      ...item,
      masterReviewed: item.chiefReviewed && checked,
    }));
    setFilteredData(updatedData);
    setSelectedMasterRows(
      checked && filteredData.every((item) => item.chiefReviewed)
        ? filteredData.map((item) => item.key)
        : []
    );
    CHANGE_ALL_CHIEF_MASTER_REVIEW_CHECK_BOX(1);
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "record_id",
      align: "center",
      key: "record_id",
      sorter: (a, b) => a.record_id - b.record_id,
      render: (text, record) => (
        <span
          style={record?.soft_delete ? { textDecoration: "line-through" } : {}}
        >
          {record?.record_id}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      align: "center",
      key: "date",
      render: (text, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
            color: record?.soft_delete ? "black" : "inherit",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Code Letter",
      dataIndex: "code_category",
      align: "center",
      key: "code_category",
      render: (text, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
            color: record?.soft_delete ? "black" : "inherit",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
            color: record?.soft_delete ? "black" : "inherit",
          }}
        >
          {formatDate(record?.created_at)}
        </span>
      ),
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
            color: record?.soft_delete ? "black" : "inherit",
          }}
        >
          {formatDate(record?.updated_at)}
        </span>
      ),
    },
    {
      title: (
        <Tooltip
          title={
            selectedChiefRows.length > 0
              ? `Selected: ${selectedChiefRows.join(", ")}`
              : "No selections"
          }
        >
          <div style={{ textAlign: "center" }}>
            <span>Reviewed By Chief Officer</span>
            <Checkbox
              style={{ marginLeft: 8 }}
              onChange={handleSelectAllChief}
              checked={
                filteredData.length > 0 &&
                filteredData.every((item) => item.chiefReviewed)
              }
              indeterminate={
                filteredData.some((item) => item.chiefReviewed) &&
                !filteredData.every((item) => item.chiefReviewed)
              }
              disabled
            />
          </div>
        </Tooltip>
      ),
      dataIndex: "updated_at",
      align: "center",
      key: "chief_review",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox
            checked={record.chiefReviewed}
            onChange={(e) => handleChiefCheckboxChange(e, record, index)}
            disabled
          />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
              color: record?.soft_delete ? "black" : "inherit",
            }}
          >
            Reviewed By CO
          </span>
        </div>
      ),
    },
    {
      title: (
        <Tooltip
          title={
            selectedMasterRows.length > 0
              ? `Selected: ${selectedMasterRows.join(", ")}`
              : "No selections"
          }
        >
          <div style={{ textAlign: "center" }}>
            <span>Reviewed By Master</span>
            <Checkbox
              style={{ marginLeft: 8 }}
              onChange={handleSelectAllMaster}
              checked={
                filteredData.length > 0 &&
                filteredData.every((item) => item.masterReviewed)
              }
              indeterminate={
                filteredData.some((item) => item.masterReviewed) &&
                !filteredData.every((item) => item.masterReviewed)
              }
              disabled
            />
          </div>
        </Tooltip>
      ),
      dataIndex: "updated_at",
      align: "center",
      key: "master_review",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox
            checked={record.masterReviewed}
            onChange={(e) => handleMasterCheckboxChange(e, record, index)}
            disabled
          />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
              color: record?.soft_delete ? "black" : "inherit",
            }}
          >
            Reviewed By Master
          </span>
        </div>
      ),
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <>
          {!record?.record_for_O && (
            <>
              {(() => {
                const isCaptain =
                  user?.data?.designation === "Chief Officer" ||
                  user?.data?.designation === "Captain";
                const openModle = user?.data?.designation === "Chief Officer";
                const isSoftDeleted = record?.soft_delete;
                const reviewed = record?.reviewed_by_master;
                const O_CODE = record?.o_code;

                const handleEdit = () => {
                  if (reviewed && isCaptain) {
                    if (openModle) {
                      localStorage.setItem("viewOnly", 1);
                      setModalVisible(!isModalVisible);
                    } else {
                      localStorage.setItem("viewOnly", 1);
                      navigate(
                        `/edit-oil-record-log/${btoa(record?.record_id)}`
                      );
                    }
                    set_record_id(record?.record_id);
                  } else {
                    localStorage.setItem("viewOnly", 1);
                    navigate(`/edit-oil-record-log/${btoa(record?.record_id)}`);
                  }
                };

                const viewButton = (
                  <Tooltip title="View">
                    <Button
                      type="primary"
                      size="small"
                      onClick={() =>
                        navigate(
                          `/view-oil-record-log/${btoa(record?.record_id)}`
                        )
                      }
                      style={{ marginRight: "5px" }}
                      icon={<EyeFilled />}
                    />
                  </Tooltip>
                );

                if (!isSoftDeleted && isCaptain && O_CODE) {
                  return (
                    <>
                      <Tooltip
                        title={
                          !voyage_status
                            ? "Editing is disabled when voyage status is inactive."
                            : "Edit"
                        }
                      >
                        <span>
                          <Button
                            disabled={!voyage_status}
                            type="primary"
                            size="small"
                            onClick={handleEdit}
                            style={{ marginRight: "15px" }}
                            icon={<EditOutlined />}
                          />
                        </span>
                      </Tooltip>

                      <Tooltip title="View">
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => {
                            localStorage.setItem("viewOnly", 0);
                            navigate(
                              `/view-oil-record-log/${btoa(record?.record_id)}`
                            );
                          }}
                          icon={<EyeFilled />}
                        />
                      </Tooltip>
                    </>
                  );
                }

                return viewButton;
              })()}
            </>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={true}
        disabled={!voyage_status}
        buttonProps={{
          text: "Add Logs",
          className: "save_btn",
          onClick: () => navigate("/add-oil-record-log"),
          onPress: () => navigate("/audit-trail-oil"),
        }}
      />
      <div className="row">
        <div
          className="col-3"
          style={{ marginBottom: "13px", marginLeft: "15px" }}
        >
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find(
                (voyage) => voyage.id === value
              );
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              LIST_OIL_RECORD_LOGBOOK_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color:
                        voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3"></div>
        <div
          className="col-6"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() =>
                DOWNLOADPDF(
                  oilparttwologdownloadPdfUrl,
                  voyage_ids,
                  startDate,
                  endDate
                )
              }
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
      <RequestFormModal2
        visible={isModalVisible}
        record_id={record_id}
        voyage_ids={voyage_ids}
        setModalVisible={setModalVisible}
        onCancel={() => {
          setModalVisible(!isModalVisible);
        }}
      />
    </>
  );
};

export default ListOilRecordLog;
